/**
 * Utility to check if the app is running in offline-only mode.
 * This is determined by the VITE_OFFLINE_ONLY environment variable at build time.
 */
export const isOfflineMode = (): boolean => {
  return import.meta.env.VITE_OFFLINE_ONLY === 'true';
};

